import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class Engine extends BasicEntity {
className: string;
code: string;
description: string;
value: string;
}

